import { Breakpoints, styled } from '@vw-marketing/us-components';

export const ModelTrimHeaderWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      width: 100%;
      justify-content: space-between;
      padding-bottom: ${theme.size.dynamic0050};
      padding-top: ${theme.size.static400};
      @media (min-width: ${Breakpoints.b960}px) {
        padding-top: 0;
        padding-bottom: ${theme.size.dynamic0100};
      }
  `;
  }}
`;

interface ModelTrimYearWrapperProps {
  isLeaseSalesEvent: boolean;
}

export const ModelTrimYearWrapper: any = styled.div<ModelTrimYearWrapperProps>`
  ${({ theme, isLeaseSalesEvent }) => {
    return `
    display: flex;
    
    align-self: stretch;
    align-items: flex-start;
    ${
      isLeaseSalesEvent
        ? `flex-direction: row; 
           gap: ${theme.size.static100};`
        : `flex-direction: column;`
    }
    ${
      isLeaseSalesEvent
        ? ``
        : `@media (min-width: ${Breakpoints.b960}px) {
          flex-direction: row;
          gap: ${theme.size.static100};
        }`
    }

    
  `;
  }}
`;

export const ModelTrimWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      gap: ${theme.size.static100};
      align-self: stretch;
      align-items: flex-start;
      
    `;
  }}
`;

export const TrimTextWrapper: any = styled.span`
  font-weight: 300;
`;

export const MSRPWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      gap: ${theme.size.static100};
      @media (min-width: ${Breakpoints.b960}px) {
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
      }
    `;
  }}
`;

export const MSRPPriceWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      gap: ${theme.size.static100};
      justify-content: flex-end;
      align-items: flex-start;
    `;
  }}
`;

export const DisclaimerWrapper: any = styled.div``;
